<script>
  import Card from "../Card.svelte";
  import CardBody from "../CardBody.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";

  export let url = "";
  export let title;
  export let description = "";

  export let imageComponent;
  export let resizeParams;
  export let widthsAt = {};

  // `w-full` prevents svg from auto scale, but is needed for other images to fill the container
  $: isSvg = imageComponent?.fields.imageAsset?.fields?.file?.url?.endsWith("svg");
</script>

<Card
  {url}
  class="h-full group rounded-10 border border-transparent focus:border-black focus:shadow-card focus-within:border-black focus-within:shadow-card active:shadow-card"
>
  <div class="h-full flex flex-col items-center p-0 rounded-10 bg-white">
    <CardBody
      {title}
      {description}
      {url}
      bodyClass="w-full h-full flex flex-col items-start gap-16 group-hover:underline overflow-hidden p-48 order-2"
      titleClass="heading-card font-normal group-focus:!no-underline leading-6.5"
    />

    <!-- image -->
    {#if imageComponent}
      <ImageComponent
        containerClass="overflow-hidden rounded-t-10"
        elementClass="{!isSvg ? 'w-full' : ''} aspect-[4/3] object-cover overflow-hidden"
        data={imageComponent}
        displayCaption={false}
        responsive
        {resizeParams}
        {...widthsAt}
      />
    {/if}
  </div>
</Card>
